import CookieConsent from '../core/cookieConsent';

/**
 * Returns the cookie value if the access is allowed, otherwise returns null.
 * @param {string} cookieName
 *
 * The regular expression matches the passed cookieName and returns an array | null based on
 * if the cookie is present in the match.
 *
 * Eg.) If we are matching for the cookie "regStatus",
 *
 * 1. If it is present
 *  matchedValue will hold something like ["regStatus=pre-register","pre-register"]
 *
 *    1.2. We picked the 1st index value for the cookie value.
 *      "pre-register" in this case.
 *
 * 2. If it is not present,
 *    matchedValue will be null
 *
 *
 * @returns {string | null}
 */
export const getCookieValue = (cookieName: string): string | null => {
  if (CookieConsent.hasConsent(cookieName)) {
    const cookiePatternRegExp = new RegExp(cookieName + '=([^;]+)');
    const matchedValued = cookiePatternRegExp.exec(document.cookie);

    return matchedValued ? decodeURI(matchedValued[1]).trim() : null;
  }

  return null;
};
